// extracted by mini-css-extract-plugin
export default {"footerItem":"p0Rzx+idGZOdipzDVou7kQ==","footerItemLink":"EblEPN7xeWwaH3AVcaCF4g==","footerItemLinkTitle":"kD-F6xzY87P+-SU3v5d5qw==","activeFooterItem":"ErePKBOo-rofdFTXnF7vDg=="};